function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import Modal from '..';
import './ModalRequestQuote.css';

var ModalRequestQuote =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ModalRequestQuote, _React$Component);

  function ModalRequestQuote() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalRequestQuote);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalRequestQuote)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      message: ''
    };

    _this.handleChange = function (e) {
      _this.setState({
        message: e.target.value
      });
    };

    return _this;
  }

  _createClass(ModalRequestQuote, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Modal, _extends({}, this.props, {
        closeable: true
      }), React.createElement("div", {
        id: "ModalRequestQuote"
      }, React.createElement("h1", null, "Send us a message"), React.createElement("textarea", {
        onChange: this.handleChange,
        value: this.state.message
      }), React.createElement("button", {
        className: "send-quote",
        onClick: function onClick() {
          return _this2.props.sendQuoteRequest(_this2.props.email, _this2.props.product, _this2.state.message);
        }
      }, "Send")));
    }
  }]);

  return ModalRequestQuote;
}(React.Component);

ModalRequestQuote.propTypes = {
  sendQuoteRequest: PropTypes.func,
  email: PropTypes.string,
  product: PropTypes.string
};
export { ModalRequestQuote as default };